import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, } from "@chakra-ui/react";
export { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, };
Modal.displayName = "Modal";
ModalOverlay.displayName = "ModalOverlay";
ModalContent.displayName = "ModalContent";
ModalHeader.displayName = "ModalHeader";
ModalFooter.displayName = "ModalFooter";
ModalBody.displayName = "ModalBody";
ModalCloseButton.displayName = "ModalCloseButton";
/**
 * A dialog is a window overlaid on either the primary window or another dialog window.
 * Contents behind a modal dialog are inert meaning that users cannot interact with content behind the dialog.
 */
export default Modal;
//# sourceMappingURL=Modal.js.map